import { styled } from "@linaria/react";
import { Button } from "primereact/button";
import { styleTokens } from "@ideally-ltd/design-tokens";
const PButton = styled(Button)<{ ref: React.LegacyRef<Button> }>`
  padding: ${styleTokens.button.padding.y} ${styleTokens.button.padding.x};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  &.p-button.p-component {
    box-shadow: #11111126 0 0 2px;
  }

  &.p-button.p-component.p-button-tiny {
    min-height: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    padding-top: 0px;
    padding-right: 0.25rem;
    padding-bottom: 0px;
    padding-left: 0.25rem;
    .p-button-label {
      font-size: 0.75rem;
    }
    i {
      font-size: 1.25rem;
    }
  }
  .p-button-label {
    letter-spacing: 0.2px;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: fit-content;
    align-items: center;
  }
  &.p-button-link {
    .p-button-label {
      color: ${styleTokens.Surface.Text.main};
    }
  }
  &.p-button.p-component.p-button.p-button-icon-only {
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.p-button-tiny {
      width: 1.5rem;
    }
  }

  &.p-button.p-button-sm,
  &.p-button.p-button-sm.p-button.p-button-icon-only {
    padding: ${styleTokens.button.sm.padding.y} ${styleTokens.button.sm.padding.x};
    height: 2rem;
    min-height: 2rem;
    min-width: 2rem;
    width: fit-content;
    .p-button-label {
      font-size: ${styleTokens.fontSize.sm};
      font-weight: ${styleTokens.button.label.font.weight};
    }
  }
  &.p-button.p-button-sm.p-button.p-button-icon-only {
    width: 2rem;
  }
  &.p-button.p-button-sm.p-button .material-symbols-sharp {
    font-size: 18px;
  }
  &.p-button-loading.p-button-loading-right {
    flex-direction: row;
  }
  &.p-button-icon-right {
    flex-direction: row-reverse;
    order: inherit !important;
  }
  &:active,
  &:focus,
  &.p-dropdown-button-menu-visible {
    box-shadow: ${styleTokens.button.raised.shadow} !important;
  }
  border: 1px solid ${styleTokens.button.primary.border.color};
  border-radius: ${styleTokens.button.border.radius};
  background: ${styleTokens.button.primary.background};
  color: ${styleTokens.button.primary.color};
  &.p-button.p-component.p-button-secondary {
    background: ${styleTokens.button.secondary.background};
    color: ${styleTokens.button.secondary.color};
    border: 1px solid ${styleTokens.button.secondary.border.color};
    .p-button-label {
      color: ${styleTokens.button.secondary.color};
    }
    &:hover {
      background: ${styleTokens.button.secondary.hover.background};
      color: ${styleTokens.button.secondary.hover.color};
      border: 1px solid ${styleTokens.button.secondary.hover.border.color};
      .p-button-label {
        color: ${styleTokens.button.secondary.hover.color};
      }
    }
    &:active,
    &.p-active,
    &.p-dropdown-button-menu-visible {
      background: ${styleTokens.button.secondary.active.background};
      color: ${styleTokens.button.secondary.active.color};
      border: 1px solid ${styleTokens.button.secondary.active.border.color};
    }
  }

  &.p-button.p-component.p-button-text {
    box-shadow: none;
    border: none;
    .p-button-label {
      color: ${styleTokens.Surface.Text.main};
    }
  }
`;
export const PButtonStyle = {
  PButton,
};
